import { Grid, Stack, Typography } from '@mui/material'
import React from 'react'

import DashboardSummaryCard from 'components/reliability-management/company-dashboard/DashboardSummaryCard'
import { CompanyReliabilityReportResponse } from 'types/api/policies/reliability-report'

const DashboardSummary: React.FC<{
  report: CompanyReliabilityReportResponse
}> = ({ report }) => {
  return (
    <Stack data-test-company-dashboard-summary direction="column" gap={2}>
      <Typography variant="h6">Biggest Weekly Changers</Typography>
      <Typography>
        These Services had the biggest change in score in the past week.
      </Typography>
      <Grid container direction="row" gap={2}>
        {report?.summary?.biggestChangers?.map((service) => (
          <Grid
            key={service.serviceId}
            item
            // the responsive settings here for wider screens are technically wasting a grid column
            // because with the gap in the grid, the cards take up more than 33.3% if we use 4 columns
            // so it won't layout correctly (MUI grid is actually just flex)
            // but also, the design is 3/4 columns so this works anyway
            lg={3}
            md={3}
            sm={12}
            xs={12}
          >
            <DashboardSummaryCard
              // make sure the card takes up the full height so they're all equal size
              // but don't embed that styling directly in the card component itself so it's more reusable
              css={{ height: '100%' }}
              service={service}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  )
}

export default DashboardSummary
